import { convertToGridColumnProps } from "~/features/quote-board/utils/quote-board-column-processor.ts";
import { TraxGrid } from "~/shared/components/trax-grid/trax-grid.tsx";
import { TraxPageHeader } from "~/shared/components/trax-page-header/trax-page-header.tsx";
import { useDeploymentType } from "~/shared/hooks/use-deployment-type.ts";
import { useGridState } from "~/shared/hooks/use-grid-state.ts";
import { useIsMobile } from "~/shared/hooks/use-is-mobile.ts";
import { GridIdentifiers } from "~/shared/utils/grid-identifier-enums.ts";

import { ReportsMobile } from "./components/reports-mobile/reports-mobile.tsx";
import { useReportColumns } from "./hooks/use-report-columns.tsx";
import styles from "./index.module.css";
import type { ReportItem } from "./types/report-types.ts";

const reports: ReportItem[] = [
	{
		id: "shipment-details",
		name: "Shipment Details",
		details:
			"Detailed information for all shipments tendered. Report includes: pickup and delivery locations, dates, status, and reference numbers.",
	},
];

export function Reports() {
	const { isInternal } = useDeploymentType();
	const isMobile = useIsMobile();
	const columns = useReportColumns();
	const { skip, take, handlePageChange, isLoadingPreference } = useGridState(
		GridIdentifiers.Reports,
	);

	return (
		<div className={styles.reportsWrapper}>
			<TraxPageHeader
				representativeType={isInternal ? undefined : "ltl"}
				showSupportMessage={!isInternal}
				title={"Reports"}
			/>
			{isMobile ? (
				<ReportsMobile reports={reports} />
			) : (
				<div className={styles.reportsGridContainer}>
					<TraxGrid
						columns={convertToGridColumnProps(columns)}
						data={reports}
						dataItemKey={"id"}
						loading={isLoadingPreference}
						onPageChange={handlePageChange}
						skip={skip}
						take={take}
					/>
				</div>
			)}
		</div>
	);
}
